import React__default from 'react';
import { Details as Details$2 } from './Details.styles.js';

var Details = function Details(_ref) {
  var _ref$packageData = _ref.packageData,
    packageData = _ref$packageData === void 0 ? [] : _ref$packageData;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, ' ', (packageData === null || packageData === void 0 ? void 0 : packageData.length) > 0 && /*#__PURE__*/React__default.createElement(Details$2, {
    className: "package-details"
  }, packageData === null || packageData === void 0 ? void 0 : packageData.map(function (detail) {
    return /*#__PURE__*/React__default.createElement("span", {
      className: "wrapper-detail",
      key: detail,
      dangerouslySetInnerHTML: {
        __html: "".concat(detail).trim()
      } // eslint-disable-line
    });
  })));
};

/* eslint-enable react/no-danger */
var Details$1 = Details;

export { Details$1 as default };
//# sourceMappingURL=Details.js.map
